<template>
    <div class="component setup">
        <h1>Willkommen</h1>
        <p>Ihre <strong>HeatControl</strong> App ist noch nicht eingerichtet.<br/>
            Bitte starten Sie die Einrichtung, indem Sie den QR-Code vom Display Ihrer Heizungssteuerung einlesen.</p>
        <div class="qr-frame">
            <div class="scanarea">
                <div class="scanline"></div>
            </div>
            <qr-stream @decode="handleDecode" @error="handleError"></qr-stream>
            <qr-dropzone></qr-dropzone>
            <br/>
            <qr-capture :capture="null" @decode="handleDecode" @error="handleError"></qr-capture>
        </div>
        <h2 class="margin-top">Benötigen Sie Hilfe bei der Einrichtung?</h2>
        <p>Dann schauen Sie sich diesen tollen Link an: Der hilft ihnen bestimmt weiter.</p>
    </div>
</template>
<script>
import { QrStream, QrCapture, QrDropzone } from 'vue3-qr-reader'

export default {
    name: "Setup",

    components: {
        QrStream,
        QrCapture,
        QrDropzone
    },

    emits: [ 'updateComponent' ],

    methods: {
        handleDecode( string )
        {

            let parsed = JSON.parse( atob( string ) )
            if( undefined !== parsed
                && null !== parsed
                && false !== parsed
                && undefined !== parsed.keys
                && undefined !== parsed.setup )
            {

                let keyStore = this.$core.getCrypto().parseKeyStore( parsed )

                if( false !== keyStore )
                {

                    this.$core.getDatabase().writeStorage( 'provisioning', JSON.stringify( parsed ) )
                        .then( () =>
                        {

                            this.$core.getProvisioning()
                                .storeSetup( keyStore )
                                .then( () =>
                                {
                                    this.$emit( 'updateComponent' )
                                } )

                        } )

                }

            }

        },

        handleError()
        {
        }
    }
}
</script>